import request from "@/utils/request";
import store from "@store";

// 权限处理表 此为管理员同意或者拒绝
export function handlePermission(data) {
  return request({
    url: "/noteCheck/api",
    method: "put",
    data
  });
}

export function askPermission(data) {
  return request({
    url: "/noteCheck/api",
    method: "post",
    data
  });
}

// export function getAmbulaceStatus(data) {
//   return request({
//     url: "/noteCheck/api",
//     method: "get",
//     data
//   });
// }

// 新的接口 获得权限列表(header 部分)
export function getPermissionList(page) {
  return request({
    url: "/srs/message-handing",
    method: "get",
    params: {
      page,
      numbers: 9,
      token: store.state.userInfo.token
    }
  });
}
